import { JsonHelper } from './JsonHelper';
export class IframeHelper {
    static injectShowpadScripts(iframe, options) {
        let document = null;
        let body = null;
        let injectScript = null;
        let injectUser = null;
        if (
        // If this is the load event of a real page, and showpad lib is specified
        iframe.src &&
            typeof options.showpadJsPath === 'string') {
            try {
                document = iframe.contentDocument;
                body = document.body;
                injectScript = document.createElement('script');
                injectScript.setAttribute('id', 'showpad-js-script');
                injectUser = document.createElement('script');
                if (options.user) {
                    injectShowpadUser();
                }
                injectShowpadLib();
            }
            catch (error) {
                if (window.console && console.error) {
                    console.error('could not add asset link helper', error);
                }
            }
        }
        if (options.trackHtmlPageLocation) {
            const trackScript = document.createElement('script');
            const iframeUrl = options.iframeUrl;
            const urlPrefix = iframeUrl.substr(0, iframeUrl.lastIndexOf('/'));
            trackScript.text = `
                    (function() {
                        var prevUrl = "";
                        var urlPrefix = "${urlPrefix}";

                        function trackUrlChange() {
                            var currentUrl = window.location.href.replace(urlPrefix, "");
                            if (currentUrl !== prevUrl && window.ShowpadLib && typeof window.ShowpadLib.trackEvent === "function") {
                                window.ShowpadLib.trackEvent([{ type: "navigation", pageLocation: currentUrl }])
                                prevUrl = currentUrl;
                            }
                        }

                        window.setInterval(trackUrlChange, 500);
                    })();
                `;
            injectScript.onload = () => {
                body.appendChild(trackScript);
            };
        }
        function injectShowpadUser() {
            injectUser.text = `window.ShowpadUser = JSON.parse(${JsonHelper.escapeJSON(JSON.stringify(options.user))});`;
            body.appendChild(injectUser);
        }
        function injectShowpadLib() {
            injectScript.src = options.showpadJsPath;
            body.appendChild(injectScript);
        }
    }
}
//# sourceMappingURL=IframeHelper.js.map